import Popup from "../../utils/popup";

class Login {
  constructor() {
    this.zapomnialesHaslaBtn = ".js-zapomniales-hasla-btn";
    this.zapomnialesHasla = $("#zapomniales_hasla");
  }

  init() {
    this.popup = new Popup(
      this.zapomnialesHasla,
      this.zapomnialesHaslaBtn,
      false,
      false
    );
  }
}

export default Login;
